<template>
  <div>
    <div class="font-bold tracking-wide mb-3 text-sm flex items-center cursor-pointer select-none" @click="showValues = !showValues">
      <div class="flex-grow">
        {{ getFilterName() }}
      </div>
      <div class="ml-3">
        <strong v-if="showValues">
          -
        </strong>
        <strong v-else>
          +
        </strong>
      </div>
    </div>
    <template v-if="showValues">
      <div v-if="['color', 'couleur_des_bulbes'].includes(filter.feature_id)" class="flex flex-wrap">
        <div
          v-for="(term, termIndex) in sortedColors(filter.values)"
          :key="termIndex"
          class="mr-2"
        >
          <div
            :style="{
              width: '34px',
              height: '34px',
              background: term.properties.code
            }"
            :title="term.properties.name"
            class="sky__filter-color rounded-full flex items-center justify-center mb-2 cursor-pointer"
            :class="{
              'selected': selected.indexOf(term.text) !== -1,
              'border': term.properties.code === '#FFFFFF'
            }"
            @click="() => {
              selectTerm(term.text)
            }"
          >
            <icon-check
              v-show="selected.indexOf(term.text) !== -1"
              :style="{
                width: '30px',
                color: term.properties.id === '2' ? 'black' : 'white'
              }"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <sky-checkbox
          v-for="(term, termIndex) in sortedTerms"
          :key="termIndex + '-' + filter.feature_id"
          class="text-sm pl-2 mb-2"
          :value="selected.indexOf(term.text) !== -1"
          @input="selectTerm(term.text)"
        >
          <template #label>
            <div class="flex items-center">
              <div class="text-xs">
                {{ term.text }}
              </div>
              <div class="text-xxs ml-2">
                ({{ term.hits }})
              </div>
            </div>
          </template>
        </sky-checkbox>
      </div>
    </template>
  </div>
</template>

<script>
import sortBy from 'lodash.sortby'
import SkyCheckbox from '../../general/SkyCheckbox'
import IconCheck from '../../general/icons/IconCheck'

export default {
  components: {
    SkyCheckbox,
    IconCheck
  },
  props: {
    filter: {
      required: true,
      type: Object
    },
    value: {
      required: false,
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selected: JSON.parse(JSON.stringify(this.value || [])),
      showValues: !this.filter.closed_by_default
    }
  },
  computed: {
    sortedTerms () {
      return this.filter.values
    }
  },
  watch: {
    selected () {
      if (JSON.stringify(this.selected) !== JSON.stringify(this.value)) {
        this.$emit('input', JSON.parse(JSON.stringify(this.selected)))
      }
    },
    value () {
      if (JSON.stringify(this.selected) !== JSON.stringify(this.value)) {
        this.selected = JSON.parse(JSON.stringify(this.value))
      }
    }
  },
  methods: {
    getFilterName () {
      return this.filter.feature_name
    },
    selectTerm (value) {
      const existing = this.selected.indexOf(value)
      if (existing !== -1) {
        this.selected.splice(existing, 1)
      } else {
        this.$emit('click:filter', {
          feature_name: this.filter.feature_name,
          value
        })
        this.selected.push(value)
      }
    },
    sortedColors (terms) {
      const colors = [...terms]
      return sortBy(colors, (a) => {
        if (!a.properties) {
          return 1000000
        }
        const priority = a.properties.priorit
        if (!priority) {
          return 1000000
        }
        return parseFloat(priority)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sky__price-filter-input {
  @apply bg-white px-2 py-1 border-sky_blue border text-xs;
}
</style>
